export default "__VITE_ASSET__6adef871__"